import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQemuComponent } from './simple-icons-qemu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQemuComponent ],
    exports:      [ SimpleIconsQemuComponent ],
    bootstrap:    []
})
export class SimpleIconsQemuModule {}
